<template>
    <div>
      <el-button type="primary" @click="openAddDialog">新增新闻</el-button>
  
      <!-- 新闻表格 -->
      <el-table :data="list" style="width: 100%; margin-top: 20px;">
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column prop="category" label="分类" width="120" />
        <el-table-column prop="title" label="标题" />
        <el-table-column prop="summary" label="摘要">
          <template slot-scope="scope">
            <span>{{ truncate(scope.row.summary, 50) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="content" label="内容">
          <template slot-scope="scope">
            <span>{{ truncate(scope.row.content, 50) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="image" label="图片" width="100">
          <template slot-scope="scope">
            <el-image
              :src="getFullImageUrl(scope.row.image)"
              style="width: 60px; height: 60px;"
              fit="cover"
            />
          </template>
        </el-table-column>
        <el-table-column prop="date" label="日期" width="120" />
        <el-table-column prop="view_count" label="浏览量" width="100" />
        <el-table-column label="操作" width="220">
          <template slot-scope="scope">
            <el-button size="small" @click="edit(scope.row)">编辑</el-button>
            <el-button size="small" type="danger" @click="remove(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
  
      <!-- 分页 -->
      <el-pagination
        style="margin-top: 20px; text-align: right;"
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="pageSize"
        :current-page.sync="page"
        @current-change="loadNews"
      />
  
      <!-- 新增/编辑对话框 -->
      <el-dialog 
  :visible.sync="showAddDialog" 
  title="新闻管理" 
  width="900px"
  @close="resetForm"
>
        <el-form :model="form" label-width="80px">
          <el-form-item label="分类">
            <el-select v-model="form.category" placeholder="请选择分类" style="width:100%">
              <el-option label="公司" value="company" />
              <el-option label="行业" value="industry" />
              <el-option label="其他" value="other" />
            </el-select>
          </el-form-item>
          <el-form-item label="标题">
            <el-input v-model="form.title" />
          </el-form-item>
          <el-form-item label="摘要">
            <el-input
              v-model="form.summary"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 8 }"
            />
          </el-form-item>
          <el-form-item label="内容">
            <el-input
              v-model="form.content"
              type="textarea"
              :autosize="{ minRows: 6, maxRows: 12 }"
              placeholder="详细内容，可使用富文本编辑器替代"
            />
          </el-form-item>
          <el-form-item label="日期">
            <el-date-picker v-model="form.date" type="date" placeholder="选择日期" style="width:100%" />
          </el-form-item>
          <el-form-item label="图片">
  <input type="file" ref="fileInput" @change="onFileChange" />
  <div v-if="form.imagePreview" style="margin-top:10px;">
    <el-image :src="form.imagePreview" style="width:120px; height:120px;" fit="cover" />
  </div>
</el-form-item>
        </el-form>
        <span slot="footer">
          <el-button @click="showAddDialog = false">取消</el-button>
          <el-button type="primary" @click="save">保存</el-button>
        </span>
      </el-dialog>
    </div>
  </template>
  
  <script>
  import { getNewsList, addNews, updateNews, deleteNews } from "@/api/news"
  import { Message } from "element-ui"
  
  export default {
    name: "News",
    data() {
      return {
        list: [],
        total: 0,
        page: 1,
        pageSize: 5,
        showAddDialog: false,
        form: {
          id: null,
          category: "",
          title: "",
          summary: "",
          image: null,
          imagePreview: null,
          date: ""
        }
      }
    },
    created() {
      this.loadNews()
    },
    methods: {
      async loadNews() {
        try {
          const res = await getNewsList({ page: this.page, pageSize: this.pageSize })
          if (res.status === 200) {
            this.list = res.data.data.list
            this.total = res.data.data.total
        
          } else {
            Message.error(res.msg || "获取新闻列表失败")
          }
        } catch (error) {
          Message.error("请求异常")
        }
      },
      openAddDialog() {
        this.resetForm()
        this.showAddDialog = true
      },
      edit(row) {
        this.form = { ...row, image: null, imagePreview: this.getFullImageUrl(row.image) }
        this.showAddDialog = true
      },
      async save() {
        try {
          const formData = new FormData()
          Object.keys(this.form).forEach((key) => {
            if (this.form[key] && key !== "imagePreview") {
              formData.append(key, this.form[key])
            }
          })
  
          let res
          if (this.form.id) {
            res = await updateNews(formData)
          } else {
            res = await addNews(formData)
          }
  
          if (res.status === 200) {
            Message.success("保存成功")
            this.showAddDialog = false
            this.loadNews()
          } else {
            Message.error(res.msg || "保存失败")
          }
        } catch (error) {
          Message.error("请求异常")
        }
      },
      async remove(id) {
        try {
          const res = await deleteNews({ id })
          if (res.status === 200) {
            Message.success("删除成功")
            this.loadNews()
          } else {
            Message.error(res.msg || "删除失败")
          }
        } catch (error) {
          Message.error("请求异常")
        }
      },
      onFileChange(e) {
        const file = e.target.files[0]
        this.form.image = file
        this.form.imagePreview = URL.createObjectURL(file)
      },
      getFullImageUrl(imagePath) {
      return this.$serverUrl + imagePath;
    },
      resetForm() {
        this.form = {
          id: null,
          category: "",
          title: "",
          summary: "",
          image: null,
          imagePreview: null,
          date: ""
        }
        if (this.$refs.fileInput) {
    this.$refs.fileInput.value = ""
       }
      },
      truncate(text, len) {
        if (!text) return ""
        return text.length > len ? text.substring(0, len) + "..." : text
      }
    }
  }
  </script>
  